import { render, staticRenderFns } from "./SkeletonCardList.vue?vue&type=template&id=608b2edc"
import script from "./SkeletonCardList.vue?vue&type=script&lang=js"
export * from "./SkeletonCardList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports